var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t, T } from 'helpers/i18n';
import { Search, SortType } from 'helpers/FuzzySearch';
import { narutalSort } from 'helpers/Utils';
import { Filter, SearchInput } from 'components';
import { Icon, Loading } from 'elements';
import { AddButton } from 'Styles';
import theme from 'Theme';
import './Table.css';
var TableVoucher = /** @class */ (function (_super) {
    __extends(TableVoucher, _super);
    function TableVoucher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            items: _this.props.items,
            sortType: undefined,
            sortHeader: undefined,
            searchTerm: undefined,
            filterSelected: 0,
            isMobile: false
        };
        _this.handleFilter = function (value) {
            _this.setState({ filterSelected: value });
        };
        _this.handleSearch = function (searchTerm) {
            _this.setState({ searchTerm: searchTerm || undefined });
        };
        _this.handleSelectHead = function (head) {
            var sort = undefined;
            if (head !== _this.state.sortHeader)
                sort = SortType.Asc;
            if (head === _this.state.sortHeader && _this.state.sortType !== SortType.Desc)
                sort = SortType.Desc;
            _this.setState({ sortType: sort, sortHeader: sort ? head : undefined });
        };
        _this.filteredItems = function () {
            var _a = _this.state, items = _a.items, filterSelected = _a.filterSelected, sortType = _a.sortType, sortHeader = _a.sortHeader, searchTerm = _a.searchTerm;
            var filters = _this.props.filters;
            var header = _this.props.header || Object.keys(_this.props.items[0]);
            var filteredItems = items;
            if (filters) {
                filteredItems = filteredItems.filter(filters[filterSelected].filter);
            }
            if (sortHeader) {
                filteredItems = narutalSort(filteredItems, sortHeader, sortType === SortType.Desc);
            }
            if (searchTerm) {
                filteredItems = Search(searchTerm, filteredItems, header);
            }
            return filteredItems;
        };
        _this.translated = function (item) {
            // console.log('items', item)
            // console.log('t(String(item))', t(String(item)))
            // console.log('t(String(item)).includes', t(String(item)).includes('@@'))
            if (item && !t(String(item)).includes('@@')) {
                // console.log('traducido', t(String(item)))
                return t(String(item));
            }
            return item;
        };
        _this.reduce = function (item) {
            // console.log(`type of item ${item}`, typeof item)
            return item;
        };
        return _this;
    }
    TableVoucher.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.items !== this.state.items)
            this.setState({ items: nextProps.items });
    };
    TableVoucher.prototype.componentDidMount = function () {
        this.onHandleResize.call(this);
        window.addEventListener('resize', this.onHandleResize.bind(this));
    };
    TableVoucher.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onHandleResize.bind(this));
    };
    TableVoucher.prototype.onHandleResize = function () {
        var isMobile = window.matchMedia('(max-width: 719px)').matches;
        this.setState({ isMobile: isMobile });
    };
    TableVoucher.prototype.render = function () {
        var _this = this;
        var _a = this.props, keyExtractor = _a.keyExtractor, onSelectItem = _a.onSelectItem, onCreate = _a.onCreate, filters = _a.filters, search = _a.search, loading = _a.loading;
        var _b = this.state, sortType = _b.sortType, sortHeader = _b.sortHeader, filterSelected = _b.filterSelected, isMobile = _b.isMobile;
        var items = this.filteredItems();
        var header = this.props.header || Object.keys(this.props.items[0]);
        if (loading)
            return React.createElement(Loading, null);
        var handle = this.props.handleSearch ? this.props.handleSearch : this.handleSearch;
        return (React.createElement(Wrapper, null,
            React.createElement(Bar, null,
                search && React.createElement(StyledSearchInput, { onChange: handle }),
                filters && (React.createElement(Filter, { filters: filters, onSelect: this.handleFilter, selectedFilter: filterSelected }))),
            items.length > 0 && !isMobile &&
                React.createElement(StyledTable, { onCreate: onCreate },
                    React.createElement("thead", null,
                        React.createElement("tr", null, header.map(function (head, index) { return (React.createElement(Th, { key: head, onClick: function () { return _this.handleSelectHead(head); } },
                            T(head),
                            React.createElement(Sort, null, head === sortHeader &&
                                (sortType === SortType.Asc ? React.createElement(SortAsc, null) : React.createElement(SortDesc, null))))); }))),
                    React.createElement("tbody", null, items.map(function (item, iter) { return (React.createElement(Tr, { key: keyExtractor(item), onClick: onSelectItem && (function () { return onSelectItem(item); }) }, header.map(function (head, index) {
                        return React.createElement(Td, { key: index, canceled: item.status === 'canceled', field_amount_paid: head === 'amount_paid', field_receipt_total: head === 'receipt_total', field_status: head === 'status', debe: (item.amount_paid < item.receipt_total) }, item[head]);
                    }))); }))),
            items.length === 0 && !isMobile &&
                React.createElement("div", null, T('noDataShow')),
            isMobile && (React.createElement("div", { style: {
                    /*backgroundColor: 'yellow',*/
                    marginBottom: Theme.common.size.bar * 2 + 'px'
                } }, items.map(function (item, index) {
                return (React.createElement("div", { onClick: onSelectItem && (function () { return onSelectItem(item); }), key: keyExtractor(item) },
                    React.createElement(Row, null, header.map(function (head, indice) { return (React.createElement(Column, { key: indice },
                        React.createElement("span", { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                /*backgroundColor: '#52c0df'*/
                            }, onClick: onSelectItem && (function () { return onSelectItem(item); }), key: head },
                            React.createElement("span", { style: {
                                    fontWeight: 'bold',
                                    maxWidth: '30%',
                                    minWidth: '125px',
                                    display: 'inlineBlock',
                                    /*backgroundColor: '#f489f0',*/
                                    flexGrow: 0,
                                    flexShrink: 0
                                }, className: "header" },
                                t(head),
                                ":"),
                            React.createElement("span", { style: {
                                    flexGrow: 0,
                                    flexShrink: 0,
                                    textTransform: 'none',
                                    /*backgroundColor: 'yellow'*/
                                } }, item[head])))); }))));
            }))),
            onCreate && (React.createElement(AddButton, { primary: true, onClick: onCreate }, T('add')))));
    };
    TableVoucher.defaultProps = {
        search: true
    };
    return TableVoucher;
}(Component));
export default TableVoucher;
var Row = function (_a) {
    var _b = _a.header, header = _b === void 0 ? false : _b, children = _a.children;
    var headerStyle = header ? {
        boxShadow: "0 1px 2px 0 ".concat(theme.color.hairline),
    } : undefined;
    return (React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', width: '100%', padding: '12px', borderBottom: "1px solid ".concat(theme.color.hairline), boxSizing: 'border-box' }, headerStyle) },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                /*flexWrap: 'nowrap',*/
                /*padding: '12px',*/
                /*borderBottom: `1px solid ${theme.color.hairline}`,*/
                /*boxSizing: 'borderBox',*/
                /*...headerStyle,*/
                /*backgroundColor: '#e1b467',*/
            } }, children)));
};
var Column = function (_a) {
    var children = _a.children;
    return (React.createElement("div", null, children));
};
var Wrapper = cxs('div')(function (_a) {
    var width = _a.width;
    return ({
        minHeight: '200px',
        width: width ? width : '100%'
    });
});
var Bar = cxs('div')({
    display: 'flex',
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
});
var StyledSearchInput = cxs(SearchInput)({
    flex: 1,
    /*borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`*/
});
var StyledTable = cxs('table')(function (_a) {
    var onCreate = _a.onCreate;
    return (__assign(__assign({ width: '100%' }, onCreate ? { marginBottom: Theme.size.bar } : undefined), { ' tr:nth-child(even)': {
            backgroundColor: Theme.color.rowBackground
        } }));
});
var StyledDiv = cxs('div')({
    ' :hover div': {
        backgroundColor: Theme.color.rowBackground
    },
    ' :nth-child(odd)': {
        backgroundColor: Theme.color.hairline
    },
});
StyledTable.propTypes = {
    onCreate: PropTypes.func
};
var Th = cxs('th')({
    padding: Theme.size.space[1],
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    cursor: 'pointer'
});
var Sort = cxs('span')({
    padding: "0 ".concat(Theme.size.space[1]),
    position: 'relative',
    '> icon': {
        left: '2px',
        position: 'absolute',
        lineHeight: 1.25,
        padding: 0
    }
});
var sortIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { name: "back", size: parseInt(Theme.fontSize.small, 0) }))); };
var SortAsc = cxs(sortIcon)({
    transform: 'rotate(90deg)'
});
var SortDesc = cxs(sortIcon)({
    transform: 'rotate(-90deg)'
});
var Tr = cxs('tr')(function (_a) {
    var onClick = _a.onClick;
    return (__assign({}, onClick ? { cursor: 'pointer' } : undefined));
});
var Td = cxs('td')(function (_a) {
    var debe = _a.debe, canceled = _a.canceled, field_amount_paid = _a.field_amount_paid, field_receipt_total = _a.field_receipt_total, field_status = _a.field_status;
    return (__assign(__assign(__assign(__assign(__assign({}, (field_amount_paid && debe) ? { color: 'orange' } : undefined), (field_receipt_total && debe) ? { color: 'orange' } : undefined), ((field_receipt_total || field_amount_paid) && !debe) ? { color: 'green' } : undefined), (field_status && canceled) ? { color: 'red' } : undefined), { padding: Theme.size.space[1], 
        /*textAlign: 'center',*/
        paddingLeft: '20px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: '200px', ':last-child': {
            /*textAlign: 'right',*/
            whiteSpace: 'nowrap'
        } }));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/TableVoucher.tsx
// module id = 1539
// module chunks = 0